export default __webpack_public_path__ + "static/08_GoodNightSita-b9ae18216c1f4729a1da64aa7aac178a.pdf";